var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"c-button button",attrs:{"href":"https://moonshot.ch/"}},[_c('div',{staticClass:"button__text"},[_vm._v("\n   "+_vm._s(_vm.data.content)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }